<template>
    <div>
      <div style="background-color: white; padding: 15px 0 15px 20px; text-align: left;">
        <div>
          <span>选择生产单元：</span>
          <el-select v-model="checkedCell" placeholder="请选择生产单元" style="border:1px solid #dcdfe6; width: 300px; border-radius: 4px; margin-right: 20px;">
            <el-option
              v-for="cell in listCell"
              :key="cell.id"
              :label="cell.name"
              :value="cell.id">
            </el-option>
          </el-select>
          <span>选择时间：</span>
          <el-date-picker
            class="date_pick"
            v-model="his_time"
            type="datetimerange"
            :picker-options="pickerOptions"
            align="right"
            value-format="yyyy-MM-dd HH:mm:ss"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :default-time="['12:00:00', '08:00:00']">
          </el-date-picker>
          <el-button type="primary" @click="getwarnLog()">确定</el-button>
        </div>
      </div>
      <div style="background-color: white; margin-top: 20px;">
        <el-table
          :data="warnLogQuery"
          border>
          <el-table-column prop="num" label="序号" sortable></el-table-column>
          <el-table-column prop="isdown" label="上/下限告警" sortable></el-table-column>
          <el-table-column prop="sta" label="操作状态" sortable></el-table-column>
          <el-table-column prop="param" label="传感器参数" sortable></el-table-column>
          <el-table-column prop="value" label="传感器数值" sortable></el-table-column>
          <el-table-column prop="time" label="时间" sortable></el-table-column>
        </el-table>
      </div>
    </div>
</template>

<script>
export default {
  data () {
    return {
      token: window.sessionStorage.getItem('token'),
      username: window.sessionStorage.getItem('username'),
      listCell: [],
      pickerOptions: {
        shortcuts: [{
          text: '最近一天',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近一周',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近一月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近半年',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 180)
            picker.$emit('pick', [start, end])
          }
        }]
      },
      his_time: [],
      checkedCell: '',
      warnLogQuery: []
    }
  },
  methods: {
    getAllCell () {
      this.axios.get(this.$store.state.ip + 'celldef/listUserCells',
        {
          params: {'username': this.username},
          headers: {'Authorization': 'Bearer ' + this.token}
        }).then(res => {
        this.listCell = res.data.data.list
      }).catch(err => {
        console.log(err)
      })
    },
    getwarnLog () {
      this.axios.get(this.$store.state.ip + 'opt/warnLogQuery',
        {
          params: {'cell_id': this.checkedCell, 'start_time': this.his_time[0], 'end_time': this.his_time[1]},
          headers: {'Authorization': 'Bearer ' + this.token}
        }).then(res => {
        this.warnLogQuery = res.data.data
        for (let i = 0; i < this.warnLogQuery.length; i++) {
          if (this.warnLogQuery[i].isdown === true) {
            this.warnLogQuery[i].isdown = '下限'
          } else {
            this.warnLogQuery[i].isdown = '上限'
          }
          if (this.warnLogQuery[i].sta === 1) {
            this.warnLogQuery[i].sta = '打开'
          } else {
            this.warnLogQuery[i].sta = '关闭'
          }
          this.warnLogQuery[i].num = i + 1
        }
      }).catch(err => {
        console.log(err)
      })
    }
  },
  created () {
    this.getAllCell()
  }
}
</script>

<style scoped>
  .date_pick {
    border: 1px solid #DCDFE6;
    border-radius: 4px;
    margin-right: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/components/userData/alarmLog.vue